<template lang="html">
 <transition name="move">
  <div class="orderAddress" v-show="showFlag" ref="orderAddress">                      
                  <el-form 
                      ref="ruleForm"
                      label-position="top"
                      size="mini"  label-width="80px"
                      style="width: 90%;margin: auto;"
                      :show-message="false"
                      hide-required-asterisk
                      :model="orderAddress" 
                      :rules="rules"
                    >
                     <!-- 姓名 -->
                    <el-form-item :label="$t('name')+'：'" prop="CustomerName">
                      <el-input v-model="orderAddress.CustomerName"></el-input>
                    </el-form-item>
                    <!-- 电话 -->
                    <el-form-item :label="$t('phone')+'：'" prop="LinkmanPhone">
                      <el-input v-model="orderAddress.LinkmanPhone"></el-input>
                    </el-form-item>

                    <!-- 地址 -->
                    <el-form-item :label="$t('address')+'：'" prop="Street">
                      <el-input v-model="orderAddress.Street"></el-input>
                    </el-form-item>

                    <!-- 邮编 -->
                    <el-form-item :label="$t('zip')+'：'" prop="Zip">
                      <el-input v-model="orderAddress.Zip"></el-input>
                    </el-form-item>

                    <!-- 城市 -->
                    <el-form-item :label="$t('city')+'：'" prop="City">
                      <el-input v-model="orderAddress.City"></el-input>
                    </el-form-item>

                    <!-- 省份 -->
                    <el-form-item :label="$t('province')+'：'" prop="Province">
                      <el-input v-model="orderAddress.Province"></el-input>
                    </el-form-item>
                  </el-form>  
    </div>
  </div>
</transition>
</template>

<script>
  import split from 'components/split/split.vue'
  import {mapState} from 'vuex'
  import BScroll from 'better-scroll'
  import eventbus from '../../common/js/eventbus.js'
  export default {
    props: {
    },
    data() {
      return {
        showFlag: false,
        state: this.$store.state,
        addressIndex: 0,
        errormsg: null,
        orderAddress: {
          ID: null,
          MiniUserID: null,
          sheet: null,
          CustomerName: null,
          LinkmanPhone: null,
          Adder: null,
          Zip: null,
          Country: null,
          Province: 'Madrid',
          City: 'Madrid',
          County: 'Spain',
          Street: null,
          TaxNumber: null
        },
       // 验证内容
        rules: {
          CustomerName: [
            { required: true, message: '请输入活动名称', trigger: 'blur' }
          ],
          LinkmanPhone: [
              { required: true, message: '请输入活动名称', trigger: 'blur' }
          ],
          Street: [
              { required: true, message: '请输入活动名称', trigger: 'blur' }
          ],
          Zip: [
              { required: true, message: '请输入活动名称', trigger: 'blur' }
          ],
          City: [
              { required: true, message: '请输入活动名称', trigger: 'blur' }
          ],
          Province: [
              { required: true, message: '请输入活动名称', trigger: 'blur' }
          ]
        }
      }
    },
    computed: mapState({
      count: 'count',
      countAlias: 'count',
      fullName(state) {
        return this.addr + state.firstName + state.lastName
      },
      cartNum(state) {
        return state.cartNum
      }
    }),
    methods: {
      show(index) {
        // 接收上一页点击的数据,使用公共数组利于保存整体结构到远端,传入index读取对应的地址元素,如果是-1就新添加一行push元素
        // console.log('接收上一页点击的数据', myaddresseditobj)
        if (index !== -1) {
          // 读取响应的元素,如果是-1就新添
          this.orderAddress = this.state.myinfo.addres[index]
        }
        this.addressIndex = index
        if (this.$store.state.dev) console.log('地址详情index  ', this.addressIndex)
        this.showFlag = true
        this.$nextTick(() => {
          if (!this.scroll) {
            this.scroll = new BScroll(this.$refs.orderAddress, {
              click: true
            })
          } else {
            this.scroll.refresh()
          }
        })
        // 跟爸爸的爸爸说下次
        eventbus.$emit('returnfun', this.hide)
      },
      hide() {
        if (this.addressIndex === -1) this.state.myinfo.addres.push(this.orderAddress) // 如果是-1就新添
        if (this.$store.state.dev) console.log('地址addres ', this.state.myinfo.addres)
        this.$http.post(this.api.createUser, this.state.myinfo)
            .then(res => {
              this.state.myinfo = res.data.data[0]
            })
            .catch(err => {
              console.error('保存地址', err.response.message)
            })
          // 叫父亲刷新
        eventbus.$emit('refresh_myaddresseditlist', this.state.myinfo)
        this.showFlag = false // 隐藏food组件
      },
      isshow() {
        return this.showFlag
      },
      // 主动触发sub
      submitForm() {
      // ref 为ruleForm 的表单验证
        this.$refs['ruleForm'].validate((valid) => {
          if (valid) {
            // 成功
            alert('submit!')
          } else {
            // 还有错误
            console.log('error submit!!')
            return false
          }
        })
      }
    },
    filters: {},
    components: {
      split
    }
  }
</script>

<style lang="scss">
  @import '../../common/sass/mixin.scss';
.orderAddress {
  position: absolute;
  left: 0;
  top: 0px;
  bottom: 0px;
  z-index: 10;
  width: 100%;
   background: #fff;
  overflow: hidden;
  
  // position: absolute;
  // left: 0;
  // top: 135px;
  // bottom: 0;
  // width: 100%;
  // overflow: hidden;
  &.move-enter-active, &.move-leave-active { // 动画过程
    transition: all .5s;
    transform: translate3d(0,0,0);
  }
  &.move-enter, &.move-leave-to { // 动画初始态
    transform: translate3d(100%,0,0);
  }
  .el-input{
    width: 95%;
  }
  // .el-form-item__error{
  //   display: none;
  // }




    .avatar {
            flex: 0 0 28px;
            width: 28px;
            height: 28px;
            margin-right: 12px;
            border-radius: 50%;
            overflow: hidden;
            img {
            width: 100%;
            }
        }
    .rating-wrapper {
        padding: 0 18px;
        // .rating-item {
        // display: flex;
        // padding: 18px 0;
        // @include border-1px(rgba(7,17,27,0.1));
        // }
        .food {
          position: relative;
          padding: 12px 0;
          box-sizing: border-box;
          @include border-1px(rgba(7,17,27,0.1));
          .name {
            display: flex;
            padding: 5px;
             width: 100%;
             line-height: 24px;
            // font-size: 14px;
            // color: rgb(7,17,27);
             background: #f7f7f7;
            // position: absolute;
            // left: 48px;
          }
          .price {
            display: flex;
            // float: left;
            width: 100%;
            // // position: absolute;
            // // bottom: 12px;
            line-height: 24px;
            // font-weight: 14px;
            // font-weight: 700;
            color: rgb(240,20,20)
          }
        }
    }
}

</style>



// WEBPACK FOOTER //
// myaddressedit.vue?2d1f6106